import * as React from "react";
import useStyles from "./TabFranchiseOpportunity.styles";
import AppTitle from "../AppTitle";
import { useMediaQuery } from "@mui/material";
import theme from "@/assets/theme";
import { DICTIONARY } from "@/utils/constants/translation.constant";
import parse from "html-react-parser";
import { useTranslation } from "next-i18next";
import { formatParagraph } from "@/utils/helpers/common";
import { useRouter } from "next/router";
import feedbackApi, {
  IDescriptionForFeedbackResponse,
} from "@/utils/api/feedback";
import { useEffect, useState } from "react";
import { useIsMounted } from "usehooks-ts";

const TabFranchiseOpportunity = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { classes } = useStyles({ params: { locale: locale! } });
  const [DescriptionForFeedback, setDescriptionForFeedback] =
    useState<IDescriptionForFeedbackResponse | null>(null);
  let getDescriptionForFeedback = async () => {
    try {
      let res = await feedbackApi.getDescriptionForFeedback({
        params: {
          type: "FRANCHISE_INQUIRY",
        },
      });
      if (res.status === 200) {
        setDescriptionForFeedback(res.data.params);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let FetchData = async () => {
    await getDescriptionForFeedback();
  };
  useEffect(() => {
    FetchData();
  }, []);
  useEffect(() => {
    if (!isMounted()) return;
    FetchData();
  }, [locale]);
  const isMounted = useIsMounted();

  return (
    <div className={classes.contentContainer}>
      <AppTitle
        title={t(DICTIONARY.FRANCHISE_OPPORTUNITY)}
        color="#4B2884"
        styleTitle={isMobile ? { padding: "24px 0" } : { padding: "50px 0" }}
      />

      <div className={classes.instruction}>
        <a href={`mailto:${"franchise@crystaljade.com"}`}>
          {parse(
            formatParagraph(
              `${DescriptionForFeedback?.description}`,
              "franchise@crystaljade.com"
            )
          )}
        </a>
      </div>
    </div>
  );
};

export default React.forwardRef(TabFranchiseOpportunity);
